import { Component } from '@angular/core';
import { DisplayComponentInterface } from '@change-requests/interfaces/display-component.interface';

@Component({
    selector: 'stock-options-display-component',
    template: `
        <div>
            {{ value ?? '-' }}
        </div>
    `,
})
export class StockOptionsDisplayComponent implements DisplayComponentInterface {
    value = '';
}
